import {useState} from "react";

const useLocalStorage = (key, initialValue) => {
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const item = window.localStorage.getItem(`passion-care-${key}`);

      return item ? JSON.parse(item) : initialValue;
    } catch (e) {
      return initialValue;
    }
  });

  const setValue = value => {
    try {
      const valueToStore = value instanceof  Function ? value(storedValue) : value;

      setStoredValue(valueToStore);

      window.localStorage.setItem(`passion-care-${key}`, JSON.stringify(valueToStore));
    } catch (e) {
      console.error(e);
    }
  };

  const removeValue = () => {
    window.localStorage.removeItem(`passion-care-${key}`);
  };

  return [storedValue, setValue, removeValue];
};

export default useLocalStorage;